import { getSocialAuthorizationUrl as original } from 'monoai:original?apis/experience/social';

import { applyStudioProvider } from './studio-choice';

export * from 'monoai:original?apis/experience/social';

export async function getSocialAuthorizationUrl(
  connectorId: string,
  state: string,
  redirectUri: string
) {
  const result = await original(connectorId, state, redirectUri);
  return { ...result, authorizationUri: applyStudioProvider(result.authorizationUri) };
}
